import { useParams } from "react-router";
import { MetadataDashboardTemplate } from "@/components/Templates/MetadataDashboardTemplate";

export default function SingleSubjectMissedDosing() {
  const { subjectId } = useParams();
  return (
    <MetadataDashboardTemplate
      type="dosage_missed_dosing"
      subjectId={subjectId}
      constants={{
        wikiLink: "/wiki/guides/exploration-singlesubject-missed-doses",
        idLink: undefined,
      }}
    />
  );
}
